import React, { useState } from 'react';
import { pb } from '../services/pocketbase';

interface LoginProps {
    onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await pb.collection('users').authWithPassword(email, password);
            onLoginSuccess();
        } catch (err: any) {
            console.error('Login error:', err);
            setError('Credenciales inválidas. Por favor intente de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#0d1117] px-4 relative overflow-hidden">
            {/* Background elements */}
            <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/10 blur-[120px] rounded-full"></div>
            <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/5 blur-[120px] rounded-full"></div>

            <div className="w-full max-w-md z-10">
                <div className="text-center mb-10">
                    <div className="inline-block px-8 py-4 bg-primary rounded-xl mb-6 shadow-2xl shadow-primary/20">
                        <h1 className="text-4xl font-black text-white axend-logo-text tracking-tighter italic">AXEND</h1>
                        <p className="text-[10px] text-white/80 font-bold tracking-[0.3em] uppercase mt-1">Technology Innovation</p>
                    </div>
                    <h2 className="text-xl font-bold text-white mb-2">Acceso al Sistema</h2>
                    <p className="text-gray-500 text-sm">Ingrese sus credenciales para continuar</p>
                </div>

                <div className="glass border border-[#30363d] rounded-3xl p-8 shadow-2xl">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Correo Electrónico</label>
                            <input 
                                type="email" 
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-[#0d1117] border border-[#30363d] rounded-2xl py-4 px-5 text-sm font-medium text-white placeholder-gray-700 focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                                placeholder="usuario@axend.com"
                            />
                        </div>

                        <div>
                            <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Contraseña</label>
                            <input 
                                type="password" 
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-[#0d1117] border border-[#30363d] rounded-2xl py-4 px-5 text-sm font-medium text-white placeholder-gray-700 focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                                placeholder="••••••••"
                            />
                        </div>

                        {error && (
                            <div className="bg-danger/10 border border-danger/20 text-danger text-[11px] font-bold px-4 py-3 rounded-xl flex items-center gap-2">
                                <span className="material-icons-round text-sm">error_outline</span>
                                {error}
                            </div>
                        )}

                        <button 
                            type="submit"
                            disabled={loading}
                            className="w-full bg-primary hover:bg-white text-white hover:text-primary py-4 rounded-2xl font-black text-xs uppercase tracking-[0.2em] transition-all shadow-xl shadow-primary/10 flex items-center justify-center gap-2"
                        >
                            {loading ? (
                                <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></span>
                            ) : (
                                <>Entrar <span className="material-icons-round text-sm">arrow_forward</span></>
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;